export enum ProcedureRecordType {
  UNSPECIFIED = 'Unspecified',
  PROCEDURE_NOTE = 'Procedure note',
  PROCEDURE = 'Procedure',
}
